import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';

@Component({
    selector: 'app-question-industry-occupation',
    templateUrl: './question-industry-occupation.component.html',
    styleUrls: ['./question-industry-occupation.component.scss'],
    standalone: false
})
export class QuestionIndustryOccupationComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() showLabel = true;
  @Input() readOnly = false;
  @Input() isEdit = false;
  @Input() showToolTip = false;
  @Input() toolTipContent = '';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Output() questionAnswer = new EventEmitter<any>();

  industries = [];
  occupations = [];
  industry = '';
  occupation = '';
  industriesLoading = false;
  occupationsLoading = false;
  industryOptions = [];
  occupationOptions = [];
  itk = '';

  constructor(private questionService: GlobalQuestionService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

      if (this.question?.answer) {
        const answer = JSON.parse(this.question?.answer);
        if (answer) {
          this.industry = answer?.industry;
          this.occupation = answer?.occupation;
          this.getIndustries();
        } else {
          this.getIndustries();
        }
      } else {
        this.getIndustries();
      }
    }
    if (changes?.showLabel?.currentValue !== changes?.showLabel?.previousValue) {
      this.showLabel = changes?.showLabel?.currentValue;
    }
    if (changes?.readOnly?.currentValue !== changes?.readOnly?.previousValue) {
      this.readOnly = changes?.readOnly?.currentValue;
    }
    if (changes?.isEdit?.currentValue !== changes?.isEdit?.previousValue) {
      this.isEdit = changes?.isEdit?.currentValue;
    }
  }

  getIndustries(): void {
    if (!this.industriesLoading && !this.readOnly) {
      this.industriesLoading = true;
      this.questionService.spinnerTransparent(true);
      const parameters = new Map<string, string>();
      this.questionService.runCommandNew(`getIndustries`, parameters)
        .subscribe(x => {
          if (!x?.length) {
            this.questionService.spinnerTransparent(false);
            this.industriesLoading = false;
            return;
          }
          this.industries = x;
          this.industryOptions = x.map(item => ({
            cent_aq_answer_id: item.industry_id,
            answer: item.industry,
            metadata: item.metadata,
            restricted: item.restricted
          }));
          this.industriesLoading = false;
          this.questionService.spinnerTransparent(false);
          if (this.industry) {
            this.getOccupations();
          }
        });
    }
  }

  getOccupations(): void {
    if (this.industry && !this.occupationsLoading) {
      this.occupationsLoading = true;
      const parameters = new Map<string, string>();
      parameters.set('industry', this.industry);
      this.questionService.runCommandNew(`getOccupationsByIndustry`, parameters)
        .subscribe(x => {
          if (!x?.length) {
            this.occupationsLoading = false;
            return;
          }
          this.occupations = x;
          this.occupationOptions = x.map(item => ({
            cent_aq_answer_id: item.occupation_id,
            answer: item.occupation_name,
            metadata: item.metadata,
            restricted: item.restricted
          }));
          this.occupationsLoading = false;
        });
    }
  }

  onIndustryChange(): void {
    this.occupation = '';
    this.itk = '';
    this.occupations = [];
    this.getOccupations();
    this.submitChanges();
  }

  onOccupationChange(): void {
    const selected = this.occupations.find(x => x.occupation_name === this.occupation);
    this.itk = selected?.itk ?? '';
    this.submitChanges();
  }

  submitChanges(): void {
    if (this.industry && this.occupation) {
      const answer = {
        industry: this.industry,
        occupation: this.occupation
      };
      this.question.answer = JSON.stringify(answer);
      this.questionAnswer.emit(this.question);
    } else {
      this.question.answer = '';
      this.questionAnswer.emit(this.question);
    }
  }
}
